<template>
  <v-card height="670" width="800">
    <div class="letters">
      <v-card-title>Select letter template</v-card-title>
      <div class="pl-4 pr-4 lettersTree">
        <div class="foldersList">
          <div v-if="loading">
            <v-progress-circular
              :size="20"
              color="primary"
              class="mr-2"
              indeterminate
            ></v-progress-circular>
            Loading...
          </div>
          <v-treeview
            v-else
            class="letterFolder"
            activatable
            hoverable
            dense
            :items="folders"
            item-text="Name"
            item-key="FullPath"
            item-children="Folders"
            @update:active="getLettersTemplates"
          >
            <!-- eslint-disable-next-line -->
            <template v-slot:prepend="{ _, open }">
              <v-icon>
                {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
              </v-icon>
            </template>
          </v-treeview>
        </div>

        <v-divider vertical></v-divider>

        <div class="filesList">
          <div v-if="filesLoading">
            <v-progress-circular
              :size="20"
              color="primary"
              class="mr-2"
              indeterminate
            ></v-progress-circular>
            Loading...
          </div>
          <v-list v-else dense class="pa-0">
            <v-list-item-group color="primary">
              <v-list-item v-for="(file, index) in files" :key="index">
                <v-list-item-content @click="selectTemplate(file)">{{ file }}</v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
      </div>
       <div style="display:flex" class="pa-5">
           <v-select :items="leaverReports" label="Reports" v-model="selectedReport"></v-select>
           <v-btn :disabled="!selectedReport" class="ml-5 mr-5" outlined color="primary" @click="runReport">Run Report</v-btn>
       </div>
      <v-card-actions>
        
         <v-btn v-if="selectedFile" color="primary" outlined @click="downloadData"
          >Download Data</v-btn>
        <v-btn v-if="selectedFile" color="primary" outlined @click="downloadTemplate"
          >Download</v-btn
        >
        <v-btn v-if="selectedFile" color="primary" outlined @click="merge">Merge</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" depressed @click="onClose">Close</v-btn>
      </v-card-actions>
    </div>
    <Dialog ref="confirmationDialog"></Dialog>
  </v-card>
</template>

<script>
import Dialog from '@/components/layout/Dialog.vue';
export default {
  name: 'Letters',
   components: {
    Dialog,
  },
  props: {
    memberId: Number,
    calculationResults: Object,
    reportKey: String,
    reportId: Number,
    formName: String,
  },
  data() {
    return {
      loading: false,
      filesLoading: false,
      folders: [],
      files: [],
      currentPath: null,
      selectedFile: null,
      leaverReports:[],
      selectedReport:null,
      loadingReport: false,
      checkingStatus:false,
    };
  },

  computed: {
    downloadPath() {
      if (this.currentPath && this.selectedFile) return this.currentPath + '/' + this.selectedFile;
      return null;
    },
  },

  mounted() {
    this.getLetterFolders();
    this.getLeaverReports();
  },
  methods: {
    async checkReportStatus() {
      try {
        if (this.checkingStatus)
          return;
        this.checkingStatus=true;  
        let response = await this.$api.get('/Report/CheckReportStatus?reportKey=' + this.reportKey);
        console.log(response.data);
        var status = response.data;
        if (status == 'Completed') {
          clearInterval(this.timer);
          this.loadingReport=false;
           await this.$refs.confirmationDialog.open(
            'Confirmation',
            'Report completed. You may now merge results with the selected letter',{confirmation:false}
          );
        }
      }
      catch(err) {
        this.loadingReport=false;
        clearInterval(this.timer);
        console.log(err);
      }  
    },
    async runReport() {
      console.log('run report '+this.formName);
      try {
          var data = { formName:this.formName, reportName:this.selectedReport,membershipId:this.memberId,inputs:this.calculationResults.Cache };
        let response  = await this.$api.post('/letters/GenerateReport', data);
        this.reportKey=response.data.Msg;
        this.reportId=response.data.Value;
        console.log(this.reportKey);
        this.timer = setInterval(this.checkReportStatus, 5000);
      }
      catch(err) {
        console.log(err);
      }
    },
    onClose() {
      this.$emit('closeQuote');
    },

    selectTemplate(file) {
      this.selectedFile = file;
    },

    async getLetterFolders() {
      this.loading = true;
      try {
        const response = await this.$api.get('/Letters/GetLetterFolders');

        if (!response.data) {
          const msg = 'Unable to load letters folders';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.folders = response.data.Folders;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.loading = false;
      }
    },

    async getLeaverReports() {
      try {
        const response = await this.$api.get('/Report/GetLeaverReports');

        if (!response.data) {
          const msg = 'Unable to load reports';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.leaverReports = response.data;
      } catch (error) {
        console.log(error.message);
      }
    },

    async getLettersTemplates(paths) {
      this.filesLoading = true;
      const path = paths[0];
      if (!path){
        this.filesLoading = false;
        return;
      }
      this.currentPath = path;
      try {
        const response = await this.$api.get('/Letters/GetLetterTemplates?path=' + path);

        if (!response.data) {
          const msg = 'Unable to load letters templates';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.files = response.data.Files;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.filesLoading = false;
      }
    },
    downloadFile(data,name,fileType) {
      if (!data) {
          const msg = 'Unable to download data';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }
        const url = window.URL.createObjectURL(
          new Blob([data], {
            type: fileType,
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();

    },
    async downloadReportData() {
       const response = await this.$api({
          method: 'GET',
          url: '/Report/ExportReportData?reportKey='+this.reportKey+'&reportId='+this.reportId,
          resposeType: 'blob',
        });
        this.downloadFile(response.data,'results.csv','text/csv');

    },
    async downloadData() {
       if (this.reportKey!=null && this.reportKey!='') {
         this.downloadReportData();
         return;
       }
       const response = await this.$api({
          method: 'POST',
          url: '/Letters/DownloadData',
          resposeType: 'blob',
          data: {
            MembershipId: this.memberId,
            LetterPath: this.downloadPath,
            PlottedItems: this.calculationResults,
          },
        });
         if (!response.data) {
          const msg = 'Unable to download data';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: 'text/csv',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'results.csv');
        document.body.appendChild(link);
        link.click();

    },
    async downloadTemplate() {
      try {
        const response = await this.$api({
          method: 'GET',
          url: '/Letters/DownloadTemplate?filePath=' + this.downloadPath,
          responseType: 'blob',
        });

        if (!response.data) {
          const msg = 'Unable to get download path';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.selectedFile);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.log(error.message);
      }
    },

    async merge() {
      if (this.reportKey) {
        await this.mergeReport();
      } else {
        await this.mergeLetter();
      }
    },
    async mergeReport() {
      try {
        const response = await this.$api({
          method: 'POST',
          url: '/Letters/MergeReport',
          data: {
            ReportKey: this.reportKey,
            LetterPath: this.downloadPath,
            ReportId: this.reportId,
          },
          responseType: 'blob',
        });

        if (!response.data) {
          const msg = 'Unable to merge report';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.downloadMergedDocument(response);
      } catch (error) {
        console.log(error.message);
      }
    },
    async mergeLetter() {
      try {
        const response = await this.$api({
          method: 'POST',
          url: '/Letters/MergeQuote',
          data: {
            MembershipId: this.memberId,
            LetterPath: this.downloadPath,
            PlottedItems: this.calculationResults,
          },
          responseType: 'blob',
        });

        if (!response.data) {
          const msg = 'Unable to merge quote';
          this.$store.commit('setNotificationMessage', { type: 'error', text: msg });
          throw new Error(msg);
        }

        this.downloadMergedDocument(response);
      } catch (error) {
        console.log(error.message);
      }
    },
    downloadMergedDocument(response) {
      const url = URL.createObjectURL(
        new Blob([response.data], {
          type: 'application/msword',
        })
      );
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', this.selectedFile);
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>

<style lang="scss">
.letters {
  height: 100%;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;

  .lettersTree {
    display: grid;
    grid-template-columns: auto auto 1fr;
    column-gap: 15px;
  }

  .filesList {
    overflow-y: auto;
  }

  .letterFolder {
    cursor: pointer;
  }
}
</style>
